import React, { useEffect, useState } from "react"
import intl from "react-intl-universal"

import styles from "./index.module.scss"

const TextTruncate = (props) => {
  const { cText, nTextMaxLenght = 130, className, ...oRest } = props

  const [bIsTruncate, setBIsTruncate] = useState(false)

  useEffect(() => {
    if (!cText?.length) return

    setBIsTruncate(cText.length > nTextMaxLenght)
  }, [cText])

  if (!cText?.length) return null

  const bTextHasToBeTruncated = cText.length > nTextMaxLenght

  const cTextTruncate = bIsTruncate ? `${cText.slice(0, nTextMaxLenght)}...` : cText

  const handleToggleObservation = () => {
    setBIsTruncate(!bIsTruncate)
  }

  return (
    <p className={`${styles.textTruncate} ${className || ''}`} {...oRest}>
      {cTextTruncate}
      {bTextHasToBeTruncated && (
        <button
          type="button"
          className={styles.textTruncateSeeMore}
          onClick={handleToggleObservation}
        >
          {bIsTruncate ? intl.get("seeMore") : intl.get("seeLess")}
        </button>
      )}
    </p>
  )
}

export default TextTruncate
